const head = `/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-use-before-define */
//
//
//           '        ____
//                   /\\   \\
//           º      / /\\   \\
//          '      / /  \\  _>
//           '    _\\ \\__>   \\__
//          ' O  ( __;·;______ )      AutoTypes
//         O º,   |  , ,  \\   \\\\      ·..~~.·~.·
//         ,,,   /| ,   , /\\  <\\\\
//         \\''\\-' ⎩,     <\\/\\  \\ \\
//          \\_/   /\\_____⎩/  >  > >
//           '___' <_(_)__>  /   \\ <
//            /    / ´ \\ |   \\___//\\\\
//           /    /      |   /  > >  \\\\
//  · ··~~~~·~·~~~~~~~·~··~~~~~·~·~~·~~~~·~~~~~·· ·  ·
//
//  Embrace the beauty of effortless typing by indulging in the benefits of them
//  sans the actual typing!
//
//  Behold! These dynamically generated types were conjured from the schemas
//  nestled within this repository. However, should you yearn to expand upon
//  these types, kindly abstain from doing so in this file, lest AutoTypes'
//  magic shall smite your changes with each schema modification.
//
//  Check out the details of Griddo AutoTypes in:
//  https://griddoio.notion.site/Griddo-AutoTypes-e7420867dd2e489c8da34a493b763cd8>
//
//  Happy magic types!
//
import { Core, Fields, Hideable, NonEmptyArray } from "@griddo/core"
//
`;

export { head };
